import projection from '../generated/pwj5n8f1.json';
import { AcceptanceManifest } from '../types';

export const pwj5n8f1AcceptanceManifest = projection as AcceptanceManifest;
